import { Component, Input } from '@angular/core';

import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { TrackingsService } from '../../../../../services/tracking.service';

@Component({
  selector: 'app-custom-image-link-box',
  templateUrl: './custom-image-link-box.component.html',
  styleUrls: ['./custom-image-link-box.component.scss']
})
export class CustomImageLinkBoxComponent {

  @Input() public firstText: string
  @Input() public secondText: string
  @Input() public iconName: string
  @Input() public iconAlt: string
  @Input() public iconShadow: boolean
  @Input() public externalRedirectUrl: string
  @Input() public showBadge: boolean
  @Input() public mixPanelElement: string
  @Input() public customClickAction: Function
  @Input() public isNews: boolean = false

  public iconSrc = 'stock/assets/icons/'

  constructor(private tracking: TrackingsService) {}

  public navigateToUrl() {
    if (this.customClickAction) {
      this.sendToMixPanel();
      this.customClickAction();
      return
    }
    this.redirect();
  }

  public redirect() {
    this.sendToMixPanel();
    window.location.href = this.externalRedirectUrl
  }

  private sendToMixPanel(): void {
     this.tracking.sendMetricsToMixpanel(
      ActionEventsEnum.CLICK,
      { element: this.mixPanelElement }
    );
  }
}
